import React from 'react';
import { useTranslation } from 'react-i18next';

interface LanguageSwitcherProps {
  theme?: 'light' | 'dark';
}

export const LanguageSwitcher: React.FC<LanguageSwitcherProps> = ({ theme = 'light' }) => {
  const { i18n } = useTranslation();

  const toggleLanguage = () => {
    const nextLang = i18n.language === 'en' ? 'fr' : 'en';
    i18n.changeLanguage(nextLang);
    localStorage.setItem('ehxcel_language', nextLang);
  };

  const themeClasses = theme === 'dark' 
    ? 'border-white/50 text-white hover:bg-white/20 hover:border-white' 
    : 'border-gray-300 text-gray-500 hover:bg-gray-100 hover:text-gray-900';

  return (
    <button 
      onClick={toggleLanguage}
      className={`text-xs font-bold uppercase tracking-widest px-3 py-1 border rounded transition-colors ${themeClasses}`}
      title="Toggle Language / Changer de langue"
    >
      {i18n.language === 'en' ? 'EN / FR' : 'FR / EN'}
    </button>
  );
};